import React, { useState, useEffect } from 'react';
import {
    Alert,
    Container,
    Header as HeaderRS,
    Content,
    Footer,
    Sidebar as Side } from 'rsuite';
import {
    Header,
    Form,
    Button,
    Segment,
    Icon,
    Dropdown,
    Divider } from 'semantic-ui-react';
import { api } from '../../../services/api';

import Sidebar from '../../../components/Sidebar';
import Navbarr from '../../../components/Navbar';

export default function RouteCreate() {
    const [routeStates, setRouteStates] = useState({
        route: {},
        formRoute: {
            nome: '',
            lojas: [],
            usuarios: []
        },
        storesOptions: [],
        usersOptions: [],
        isLoading: false
    });


    const resetRouteStates = () => {
        setRouteStates( prevState => ({
            ...prevState,
            formRoute: {
                nome: '',
                lojas: [],
                usuarios: []
            },
            //storeOptions: [],
            //usersOptions: [],
            isLoading: false
        }));
    }

    const handleNomeChange = (e, {value}) => {
        setRouteStates( prevState => ({
            ...prevState,
            formRoute: {
                ...prevState['formRoute'],
                nome: value
            }
        }));
    }

    const handleStoresChange = (e, {value}) => {
        setRouteStates((prevState) => ({
            ...prevState,
            formRoute: {
                ...prevState['formRoute'],
                lojas: value
            }
        }));
    }

    const handleUsersChange = (e, {value}) => {
        setRouteStates((prevState) => ({
            ...prevState,
            formRoute: {
                ...prevState['formRoute'],
                usuarios: value
            }
        }));
    }

    async function handlePost() {
        try {
            setRouteStates( prevState => ({
                ...prevState,
                isLoading: true,
            }));
            const usuarios = [];
            const lojas = [];

            routeStates['formRoute']['usuarios'].forEach(
                usr => usuarios.push({'email':usr})
            );

            routeStates['formRoute']['lojas'].forEach(
                loja => lojas.push({'id':loja})
            );

            /*const data = */await api.postRoute(routeStates['formRoute']['nome'], usuarios, lojas);
            Alert.success("Rota cadastrada com sucesso!");
            resetRouteStates();
        } catch (err) {
            Alert.error("Falha ao cadastrar rota. Verifique os campos e tente novamente.");
            console.error('Falha ao cadastrar rota: ', err);
            setRouteStates( prevState=> ({
                ...prevState,
                isLoading: false,
            }));
        }
    }

    useEffect(() => {
        async function fetchStores() {
            try {
                const storesOptions = [];
                const stores = await api.getStores();
                stores.forEach(
                    stor => {
                        storesOptions.push({key: stor['id'],
                                            text: stor['nome'],
                                            value: stor['id']});
                    }
                );
                setRouteStates(prevState => ({
                    ...prevState,
                    stores: stores,
                    storesOptions: storesOptions,
                }));
            } catch (err) {
                console.error('Falha ao obter lojas: ',err);
            }
        }

        async function fetchUsers() {
            try {
                const usersOptions = [];
                const data = await api.getUsers();
                const users = data.filter( element => element['role'] === 'ROLE_USUARIO');
                users.forEach(
                    usr => {
                        usersOptions.push({key: usr['email'],
                                            text: usr['nome'],
                                            value: usr['email']});
                    }
                );
                setRouteStates(prevState => ({
                    ...prevState,
                    usersOptions: usersOptions,
                }));
            } catch (err) {
                console.error('Falha ao obter usuários: ', err);
            }
        }

        fetchStores();
        fetchUsers();
    },[]);

    return (
        <Container className="r-content">
            <Side style={{ flex: '0 0 auto', width: 'auto' }}>
                <Sidebar page={"routenew"}></Sidebar>
            </Side>
            <Container>
                <HeaderRS>
                    <Navbarr></Navbarr>
                </HeaderRS>
                <Content style={{ backgroundColor: '#FAFAFA', padding: '5px' }}>
                    <div>
                        <Segment
                            loading={routeStates['isLoading']}
                            style={{ boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' }}
                            >
                            <Header as='h3' floated='left'>
                                Nova Rota
                            </Header>

                            <Divider clearing />
                            Preencha os campos com as informações da rota
                            <Form style={{marginTop: '15px'}}>
                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            iconPosition='left'
                                            icon='map signs'
                                            fluid label='Nome'
                                            placeholder='Nome'
                                            value={routeStates['formRoute']['nome']}
                                            onChange={handleNomeChange}
                                        />
                                    </Form.Group>


                                    <Form.Group inline style={{marginBottom: '4px'}}>
                                            <label>Promotores</label>
                                        </Form.Group>
                                    <Form.Group inline>
                                        <Dropdown
                                            options={routeStates['usersOptions']}
                                            placeholder='Escolha usuários'
                                            search
                                            selection
                                            fluid
                                            multiple
                                            value={routeStates['formRoute']['usuarios']}
                                            onChange={handleUsersChange}
                                        />
                                    </Form.Group>

                                    {/* Dropdown lojas*/}
                                    <Form.Group inline style={{marginBottom: '4px'}}>
                                        <label>Lojas</label>
                                    </Form.Group>
                                    <Form.Group inline>
                                        <Dropdown
                                            options={routeStates['storesOptions']}
                                            placeholder='Escolha lojas'
                                            search
                                            selection
                                            fluid
                                            multiple
                                            value={routeStates['formRoute']['lojas']}
                                            onChange={handleStoresChange}
                                        />
                                    </Form.Group>
                                    <Form.Group>
                                        <Button
                                            style={{marginLeft: '7px', marginTop: '7px'}}
                                            primary
                                            size="mini"
                                            floated='right'
                                            onClick={handlePost}
                                            type='submit'>
                                                <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                                                    <Icon name='save'/> Salvar
                                                </div>
                                        </Button>
                                    </Form.Group>
                                </Form>
                            </Segment>
                        </div>
                    </Content>
                <Footer></Footer>
            </Container>
        </Container>
    );
}
